module.exports = __webpack_public_path__ + "img/HISTORIA-SELE.0bcccf2a.jpg";